var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 106,
    viewBox: "0 0 91 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1702)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.739 27.62v44.64c0 15.48-7.2 23.4-21.72 23.4h-2.76c-15 0-21.96-7.8-21.96-23.4V27.62c0-15.12 6.84-23.28 21.72-23.28h2.88c15.24 0 21.84 8.16 21.84 23.28zm-16.08 44.64V27.74c0-6.72-2.64-9.48-7.2-9.48-4.68 0-7.08 2.76-7.08 9.48v44.52c0 6 2.16 9.36 7.2 9.36 4.92 0 7.08-3.36 7.08-9.36zM17.101 27.62H4.381V15.26c11.52 0 14.28-2.64 15.96-9.96h12.48v89.28h-15.72V27.62z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.739 27.62v44.64c0 15.48-7.2 23.4-21.72 23.4h-2.76c-15 0-21.96-7.8-21.96-23.4V27.62c0-15.12 6.84-23.28 21.72-23.28h2.88c15.24 0 21.84 8.16 21.84 23.28zm-16.08 44.64V27.74c0-6.72-2.64-9.48-7.2-9.48-4.68 0-7.08 2.76-7.08 9.48v44.52c0 6 2.16 9.36 7.2 9.36 4.92 0 7.08-3.36 7.08-9.36zM17.101 27.62H4.381V15.26c11.52 0 14.28-2.64 15.96-9.96h12.48v89.28h-15.72V27.62z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1702",
    x: -4.119,
    y: -4.16,
    width: 94.358,
    height: 109.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1702"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1702",
    result: "effect2_dropShadow_2805_1702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1702",
    result: "shape"
  })))));
}
Svg10.displayName = '10';
export default Svg10;